module.exports = __webpack_public_path__ + "img/ex-qr-search-inventory2.64ce214b.svg";